export const GLOBAL_STATE = 'Analytics'

export const ANALYTICS_ADMISSION_OFFICE = 'ANALYTICS_ADMISSION_OFFICE' as const
